
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import implicitModules from "./-embroider-implicit-modules.js";


import * as amdModule0 from "./config/environment.js"
import * as amdModule1 from "./content/companies.ts"
import * as amdModule2 from "./content/home.ts"
import * as amdModule3 from "./deprecation-workflow.js"
import * as amdModule4 from "./instance-initializers/console-greeting.ts"
import * as amdModule5 from "./instance-initializers/ember-intl.ts"
import * as amdModule6 from "./instance-initializers/load-translations.ts"
import * as amdModule7 from "./lib/canvas/mars-scene.ts"
import * as amdModule8 from "./lib/canvas/shooting-stars.ts"
import * as amdModule9 from "./lib/canvas/sky-stars.ts"
import * as amdModule10 from "./router.js"
import * as amdModule11 from "./services/debug.ts"
import * as amdModule12 from "./services/device-detection.js"
import * as amdModule13 from "./services/intl.ts"
import * as amdModule14 from "./services/loading.ts"
import * as amdModule15 from "./services/mars-canvas-registry.ts"
import * as amdModule16 from "./services/meta.ts"
import * as amdModule17 from "./services/store.js"
import * as amdModule18 from "./utils/schema-org.ts"
import * as amdModule19 from "./services/-ensure-registered.js"
import * as amdModule20 from "./services/page-title.js"
import * as amdModule21 from "./initializers/ember-data.js"
import * as amdModule22 from "./transforms/date.js"
import * as amdModule23 from "./transforms/number.js"
import * as amdModule24 from "./transforms/string.js"
import * as amdModule25 from "./transforms/boolean.js"
import * as amdModule26 from "./data-adapter.js"
import * as amdModule27 from "./templates/application.hbs"
import * as amdModule28 from "./routes/application.ts"
import * as amdModule29 from "./templates/contact-success.hbs"
import * as amdModule30 from "./routes/contact-success.ts"
import * as amdModule31 from "./templates/en.hbs"
import * as amdModule32 from "./routes/en.ts"
import * as amdModule33 from "./templates/en/index.hbs"
import * as amdModule34 from "./routes/en/index.ts"
import * as amdModule35 from "./templates/en/services.hbs"
import * as amdModule36 from "./routes/en/services.ts"
import * as amdModule37 from "./templates/es.hbs"
import * as amdModule38 from "./routes/es.ts"
import * as amdModule39 from "./templates/es/index.hbs"
import * as amdModule40 from "./routes/es/index.ts"
import * as amdModule41 from "./templates/es/services.hbs"
import * as amdModule42 from "./routes/es/services.ts"
import * as amdModule43 from "./routes/index.ts"
import * as amdModule44 from "./templates/not-found.hbs"
import * as amdModule45 from "./routes/not-found.ts"

let exportFastbootModules = {};



window._embroiderRouteBundles_ = [
  {
    names: ["en.services.ember"],
    load: function() {
      return import("@embroider/core/route/en.services.ember");
    }
  },
  {
    names: ["es.services.ember"],
    load: function() {
      return import("@embroider/core/route/es.services.ember");
    }
  },
]


export default Object.assign(
  {},
  implicitModules,
  {
"madow-tech/config/environment": amdModule0,
"madow-tech/content/companies": amdModule1,
"madow-tech/content/home": amdModule2,
"madow-tech/deprecation-workflow": amdModule3,
"madow-tech/instance-initializers/console-greeting": amdModule4,
"madow-tech/instance-initializers/ember-intl": amdModule5,
"madow-tech/instance-initializers/load-translations": amdModule6,
"madow-tech/lib/canvas/mars-scene": amdModule7,
"madow-tech/lib/canvas/shooting-stars": amdModule8,
"madow-tech/lib/canvas/sky-stars": amdModule9,
"madow-tech/router": amdModule10,
"madow-tech/services/debug": amdModule11,
"madow-tech/services/device-detection": amdModule12,
"madow-tech/services/intl": amdModule13,
"madow-tech/services/loading": amdModule14,
"madow-tech/services/mars-canvas-registry": amdModule15,
"madow-tech/services/meta": amdModule16,
"madow-tech/services/store": amdModule17,
"madow-tech/utils/schema-org": amdModule18,
"madow-tech/services/-ensure-registered": amdModule19,
"madow-tech/services/page-title": amdModule20,
"madow-tech/initializers/ember-data": amdModule21,
"madow-tech/transforms/date": amdModule22,
"madow-tech/transforms/number": amdModule23,
"madow-tech/transforms/string": amdModule24,
"madow-tech/transforms/boolean": amdModule25,
"madow-tech/data-adapter": amdModule26,
"madow-tech/templates/application": amdModule27,
"madow-tech/routes/application": amdModule28,
"madow-tech/templates/contact-success": amdModule29,
"madow-tech/routes/contact-success": amdModule30,
"madow-tech/templates/en": amdModule31,
"madow-tech/routes/en": amdModule32,
"madow-tech/templates/en/index": amdModule33,
"madow-tech/routes/en/index": amdModule34,
"madow-tech/templates/en/services": amdModule35,
"madow-tech/routes/en/services": amdModule36,
"madow-tech/templates/es": amdModule37,
"madow-tech/routes/es": amdModule38,
"madow-tech/templates/es/index": amdModule39,
"madow-tech/routes/es/index": amdModule40,
"madow-tech/templates/es/services": amdModule41,
"madow-tech/routes/es/services": amdModule42,
"madow-tech/routes/index": amdModule43,
"madow-tech/templates/not-found": amdModule44,
"madow-tech/routes/not-found": amdModule45,
  },
  exportFastbootModules
);
